var _path, _path2, _g, _g2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMp3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.182,
    height: 38.814,
    viewBox: "0 0 30.182 38.814",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "mp3",
    transform: "translate(-510.146 329.733)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2102",
    "data-name": "Path 2102",
    d: "M314.252,1253.267l9.2,9.068h-9.2Z",
    transform: "translate(216.875 -1583)",
    fill: "#5d5d5d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_86_5",
    "data-name": "XMLID 86 5",
    transform: "translate(216.875 -1583)",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2103",
    "data-name": "Path 2103",
    d: "M314.252,1253.267H295.4v38.814h28.051v-29.757Z",
    fill: "#5d5d5d"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_84_5",
    "data-name": "XMLID 84 5",
    transform: "translate(216.875 -1583)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1466",
    "data-name": "Rectangle 1466",
    width: 28,
    height: 13.286,
    transform: "translate(293.271 1271.459)",
    fill: "#b14b38"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_83_5",
    "data-name": "XMLID 83 5",
    transform: "translate(216.875 -1583)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2104",
    "data-name": "Path 2104",
    d: "M293.271,1284.743l2.127,1.8v-1.8Z",
    fill: "#b14b38"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_.mp3",
    "data-name": " .mp3",
    transform: "translate(216.875 -1583)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2039",
    "data-name": "Group 2039",
    style: {
      isolation: "isolate"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2105",
    "data-name": "Path 2105",
    d: "M294.723,1281.869a.66.66,0,0,1,.468-1.128.607.607,0,0,1,.452.192.682.682,0,0,1,0,.936.607.607,0,0,1-.452.192A.636.636,0,0,1,294.723,1281.869Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2106",
    "data-name": "Path 2106",
    d: "M305.381,1276.344a2.033,2.033,0,0,1,.841.845,2.83,2.83,0,0,1,.308,1.372V1282h-.957v-3.3a1.888,1.888,0,0,0-.431-1.334,1.514,1.514,0,0,0-1.165-.463,1.556,1.556,0,0,0-1.2.484,1.993,1.993,0,0,0-.446,1.4V1282h-.958v-3.3a1.883,1.883,0,0,0-.431-1.334,1.512,1.512,0,0,0-1.165-.463,1.554,1.554,0,0,0-1.2.484,1.988,1.988,0,0,0-.447,1.4V1282h-.968v-5.829h.968v.84a1.905,1.905,0,0,1,.771-.7,2.337,2.337,0,0,1,1.069-.245,2.531,2.531,0,0,1,1.3.33,2.017,2.017,0,0,1,.84.968,1.913,1.913,0,0,1,.809-.957,2.379,2.379,0,0,1,1.255-.341A2.548,2.548,0,0,1,305.381,1276.344Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2107",
    "data-name": "Path 2107",
    d: "M309.981,1276.407a2.568,2.568,0,0,1,1.325-.335,2.717,2.717,0,0,1,1.409.373,2.623,2.623,0,0,1,.995,1.047,3.28,3.28,0,0,1,.362,1.569,3.349,3.349,0,0,1-.362,1.575,2.654,2.654,0,0,1-2.4,1.457,2.549,2.549,0,0,1-1.314-.335,2.4,2.4,0,0,1-.866-.835v3.839h-.969v-8.594h.969v1.074A2.311,2.311,0,0,1,309.981,1276.407Zm2.835,1.505a1.839,1.839,0,0,0-.717-.744,1.985,1.985,0,0,0-.995-.256,1.932,1.932,0,0,0-.984.261,1.9,1.9,0,0,0-.723.755,2.571,2.571,0,0,0,0,2.3,1.907,1.907,0,0,0,.723.755,1.93,1.93,0,0,0,.984.26,1.957,1.957,0,0,0,.995-.26,1.873,1.873,0,0,0,.717-.755,2.417,2.417,0,0,0,.267-1.165A2.364,2.364,0,0,0,312.816,1277.912Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2108",
    "data-name": "Path 2108",
    d: "M315.965,1274.711a2.71,2.71,0,0,1,1.766-.554,2.793,2.793,0,0,1,1.25.261,1.878,1.878,0,0,1,.8.707,1.908,1.908,0,0,1,.271,1.011,1.787,1.787,0,0,1-.377,1.138,1.7,1.7,0,0,1-.984.617v.053a1.966,1.966,0,0,1,1.1.671,2.012,2.012,0,0,1,.4,1.308,2.162,2.162,0,0,1-.277,1.09,1.908,1.908,0,0,1-.829.761,2.958,2.958,0,0,1-1.33.276,2.834,2.834,0,0,1-1.851-.59,2.288,2.288,0,0,1-.809-1.676h.936a1.609,1.609,0,0,0,.522,1.043,1.711,1.711,0,0,0,1.191.4,1.535,1.535,0,0,0,1.133-.388,1.36,1.36,0,0,0,.388-1.005,1.275,1.275,0,0,0-.531-1.149,2.954,2.954,0,0,0-1.607-.351h-.245v-.808h.256a2.884,2.884,0,0,0,1.478-.325,1.065,1.065,0,0,0,.5-.973,1.175,1.175,0,0,0-.367-.905,1.487,1.487,0,0,0-1.047-.34,1.6,1.6,0,0,0-1.064.34,1.379,1.379,0,0,0-.479.915h-.946A2.076,2.076,0,0,1,315.965,1274.711Z",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMp3);
export default __webpack_public_path__ + "static/media/mp3.691792bfcfdc5d0932f649ef27bb299f.svg";
export { ForwardRef as ReactComponent };